import { Button } from 'reactstrap'
import { makeInteger } from '../utils'

const queryDetail = {
  printSetList: 170877,
  practiceTracks: 170900,
}

const totb = {
  output_hook: (documentId, queryDetailId, data) => {
    console.log('totb.output_hook', documentId, queryDetailId, data)

    switch(makeInteger(queryDetailId)) {
      case queryDetail.printSetList:
        return <Button size="sm" onClick={() => alert('Print Set List')}>Print Set List</Button>
      case queryDetail.practiceTracks:
        return <Button size="sm" onClick={() => alert('Practice Tracks')}>Practice Tracks</Button>
      default:
    }
  },
  validation_hook: async function validation_hook(fieldInput, objectId, formInputs) {
    console.log('totb.validation_hook', fieldInput, objectId, formInputs)

    let validationMessage = ''

    // switch (makeInteger(fieldInput.field.id)) {
    //   case FIELD_ID.query.name:
    //     if (fieldInput.currentValue) {
    //       const results = await window.apolloClient.query({ query: SEARCH_BY_NAME, variables: { name: fieldInput.currentValue } })
    //       if (results.data.searchByName && makeInteger(results.data.searchByName.id) !== makeInteger(objectId)) {
    //         validationMessage = `${fieldInput.field.name} "${fieldInput.currentValue}" is already being used.`
    //       }
    //     }
    //     break
    //   default:
    //     console.log(`!!!!!!!!!!!!!!!!!!!!!!!!!!!! document_model.validation_hook NOT HANDLED FOR FIELD: ${fieldInput.field.name}`)
    //     validationMessage = ''
    // }
    // console.log('validationMessage: ', validationMessage)
    return validationMessage
  },

}

export default totb